module.exports = __webpack_public_path__ + "img/gallery-24.44d79c70.jpg";